/* eslint-disable */
import React from 'react';
import { store } from 'store';
import { fetchRecentClients, searchCentralClients, clearCentralClients } from 'modules/clients/actions';
import { SEARCH_LEVEL, SEARCH_BY_FIELD } from 'constants/search';

/**
 * Search clients hook
 * Use it in React component if you need to search for clients
 *
 * Example:
 * const Component = ({search}) => {
 *   const [page, setPage] = useState(1);
 *   const searchLimit = search.length >= 2;
 *   const searchRef = useRef(false);
 *
 *   useSearchClients(search, searchRef, searchLimit, tabValue, searchField);
 *
 *   useEffect(() => {
 *     setPage(1);
 *   }, [search])
 *
 *  ... you code here
 *
 *   return <>...</>
 * }
 */
export const useSearchClients = (
  search = '',
  searchRef = {},
  searchLimit,
  tabValue = SEARCH_LEVEL.CLIENT_LIST,
  searchField = SEARCH_BY_FIELD.PHONE,
  withAddClientButton = false,
) => {
  React.useEffect(() => {
    store.dispatch(fetchRecentClients());

    return () => {
      store.dispatch(clearCentralClients());
    };
  }, []);

  React.useEffect(() => {
    if (searchLimit) {
      store.dispatch(
        searchCentralClients({
          search,
          field: searchField,
          searchLevel: tabValue,
          page: 1,
          withAddClientButton,
        }),
      );
      searchRef.current = true;
    } else {
      store.dispatch(clearCentralClients());
      searchRef.current = false;
    }
  }, [search, tabValue, searchField]);
};

export default useSearchClients;
